import React, { useReducer, useEffect } from "react";
import {
  Table,
  Row,
  Col,
  Button,
  Alert,
  Accordion,
  Card,
} from "react-bootstrap";
import ModuleDisplayEmail from "../modules/fieldsDisplay/ModuleDisplayEmail";
import ModuleDisplayPhone from "../modules/fieldsDisplay/ModuleDisplayPhone";
import {
  listingInitialState,
  listingReducer,
} from "../../../reducers/module/listingReducer";
import axios from "../../../config/axios";
import { GiMeal } from "react-icons/gi";
import { getCurrencyCode, getFullName } from "../../../helpers/CommonHelper";
import ModuleDisplayDateTime from "../modules/fieldsDisplay/ModuleDisplayDateTime";
import ModuleDisplayBoolean from "../modules/fieldsDisplay/ModuleDisplayBoolean";
import { Link, useNavigate } from "react-router-dom";
import { GiCancel } from "react-icons/gi";
import { RiPassExpiredFill } from "react-icons/ri";
import { MdNoMeals } from "react-icons/md";
import { FaCirclePause, FaCirclePlay } from "react-icons/fa6";
import StatsListing from "../shared/infoListing/StatsListing";
import moduleConfig from "../../modules/orders/moduleConfig";
import ModuleDisplayDate from "../modules/fieldsDisplay/ModuleDisplayDate";
function SubscriptionContent({ setParent, parent }) {
  const [listingState, listingDispatch] = useReducer(
    listingReducer,
    listingInitialState
  );

  const navigate = useNavigate();

  const handleNavigate = (url) => {
    navigate(url);
  };
  const loadItems = async () => {
    listingDispatch({ type: "FETCH_REQUEST" });
    setParent(true);

    try {
      // First API call
      const res1 = await axios.get(`subscriptions/get-stats`);

      // Second API call (after first)
      const res2 = await axios.get(`subscriptions?limit=5`);

      // Combine both API data if needed
      const combinedData = {
        stats: res1.data?.stats,
        items: res2.data?.items,
      };

      listingDispatch({
        type: "FETCH_SUCCESS",
        payload: combinedData,
      });
    } catch (error) {
      listingDispatch({
        type: "FETCH_FAILURE",
        payload: error,
      });
    } finally {
      setParent(false);
    }
  };

  useEffect(() => {
    loadItems();
  }, []);

  return (
    <>
      <Row className="my-2">
        <Col>
          {/* {/* {listingState.isFetching === true && <FullPageOverlay />} */}
        
          {listingState.hasFetchingError && (
            <Alert variant="warning mb-0 mt-1">
              OOPS!!! Something went wrong, please try again later.
            </Alert>
          )}
          {listingState.data && listingState?.data?.stats && (
            <>
              <Row className="my-2">
                <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                  <a
                    onClick={() => handleNavigate("/subscriptions")}
                    title="Click to view all subscriptions"
                    className="cursor-pointer"
                  >
                    <div className="info-box bg-linear-6 text-white">
                      <span className="info-box-icon">
                        <GiMeal size={40} />
                      </span>
                      <div className="info-box-content">
                        <span className="info-box-text">
                          Total Subscriptions
                        </span>
                        <span
                          className="info-box-number fs-3"
                          style={{ lineHeight: "30px" }}
                        >
                          {listingState?.data?.stats?.total}
                        </span>
                      </div>
                    </div>
                  </a>
                </Col>
                {listingState?.data?.stats?.active >= 0 && (
                  <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                    <a
                      onClick={() =>
                        handleNavigate(`/subscriptions?status=Active`)
                      }
                      title="Click to view all active subscriptions"
                      className="cursor-pointer"
                    >
                      <div className="info-box bg-linear-1 text-white">
                        <span className="info-box-icon">
                          <FaCirclePlay size={40} />
                        </span>
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Active Subscriptions
                          </span>
                          <span
                            className="info-box-number fs-3"
                            style={{ lineHeight: "30px" }}
                          >
                            {listingState?.data?.stats?.active}
                          </span>
                        </div>
                      </div>
                    </a>
                  </Col>
                )}
                {listingState?.data?.stats?.paused >= 0 && (
                  <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                    <a
                      onClick={() =>
                        handleNavigate(`/subscriptions?status=Paused`)
                      }
                      title="Click to view paused subscriptions"
                      className="cursor-pointer"
                    >
                      <div className="info-box bg-linear-2 text-white">
                        <span className="info-box-icon">
                          <FaCirclePause size={40} />
                        </span>
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Paused Subscriptions
                          </span>
                          <span
                            className="info-box-number fs-3"
                            style={{ lineHeight: "30px" }}
                          >
                            {listingState?.data?.stats?.paused}
                          </span>
                        </div>
                      </div>
                    </a>
                  </Col>
                )}
                {listingState?.data?.stats?.cancelled >= 0 && (
                  <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                    <a
                      onClick={() =>
                        handleNavigate(`/subscriptions?status=Cancelled`)
                      }
                      title="Click to view cancelled subscriptions"
                      className="cursor-pointer"
                    >
                      <div className="info-box bg-linear-11 text-white">
                        <span className="info-box-icon">
                          <GiCancel size={40} />
                        </span>
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Cancelled Subscriptions
                          </span>
                          <span
                            className="info-box-number fs-3"
                            style={{ lineHeight: "30px" }}
                          >
                            {listingState?.data?.stats?.cancelled}
                          </span>
                        </div>
                      </div>
                    </a>
                  </Col>
                )}
                {listingState?.data?.stats?.expired >= 0 && (
                  <Col xl={3} lg={3} md={3} sm={3} xs={12}>
                    <a
                      onClick={() =>
                        handleNavigate(`/subscriptions?status=Expired`)
                      }
                      title="Click to view expired subscriptions"
                      className="cursor-pointer"
                    >
                      <div className="info-box bg-linear-10 text-white">
                        <span className="info-box-icon">
                          <MdNoMeals size={40} />
                        </span>
                        <div className="info-box-content">
                          <span className="info-box-text">
                            Expired Subscriptions
                          </span>
                          <span
                            className="info-box-number fs-3"
                            style={{ lineHeight: "30px" }}
                          >
                            {listingState?.data?.stats?.expired}
                          </span>
                        </div>
                      </div>
                    </a>
                  </Col>
                )}
              </Row>
            </>
          )}
          {listingState?.data?.items &&
            listingState?.data?.items?.length > 0 && (
              <Row>
                <Col xl={12} lg={12} md={12} sm={12} xs={12}>
                  <div className="d-flex align-items-center justify-content-between">
                    <div>
                      <h5 className="text-bold fs-9 ">Recent Subscriptions</h5>
                    </div>
                    <div>
                      <Link
                        to={"/subscriptions"}
                        className="btn btn-xs btn-custom-2 fontItalic"
                      >
                        {" "}
                        View More
                      </Link>
                    </div>
                  </div>

                  <div className="overflow-x-auto mt-0">
                    <table class="custom-table mt-1 ">
                      <thead>
                        <tr>
                          <th>Customer</th>
                          <th>Plan</th>
                          <th>Meals</th>
                          <th>Status</th>
                        </tr>
                      </thead>

                      <tbody>
                        {listingState?.data?.items.map((item, index) => {
                          return (
                            <tr title="View details" onClick={() => handleNavigate(`/subscriptions/${item._id}`)}>
                              <td>
                                {item?.customer?.firstName}{" "}
                                {item?.customer?.lastName}
                              </td>
                              <td>{item?.plan?.title}</td>
                              <td>
                                {item?.subscribedMeals?.length > 0
                                  ? item.subscribedMeals
                                      .map((m) => m.meal?.title)
                                      .join(" , ")
                                  : "None selected"}
                              </td>
                              <td>
                                <span
                                  class={`status ${
                                    item.status.toLowerCase() === "active"
                                      ? "active"
                                      : item.status.toLowerCase() === "paused"
                                      ? "inactive"
                                      : item.status.toLowerCase() ===
                                        "cancelled"
                                      ? "cancelled"
                                      : "black"
                                  }`}
                                >
                                  {item.status}
                                </span>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </Col>
              </Row>
            )}
        </Col>
      </Row>
    </>
  );
}

export default SubscriptionContent;
